import { useEffect, useState } from "react";

import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { getAccessToken } from "./token";
import { API_URL } from "../enums/api";
import { ImageDataContent, Optional } from "../enums/types";

const useGetImage = (imageId?: string) => {
  const { t } = useTranslation();
  const [isImageDownloading, setIsImageDownloading] = useState<boolean>(false);
  const [downloadedImage, setDownloadedImage] =
    useState<Optional<string>>(null);

  useEffect(
    function fetchImage() {
      if (imageId) {
        setIsImageDownloading(true);

        axios
          .get<ImageDataContent>(`${API_URL}bo/media/${imageId}`, {
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
            },
          })
          .then(({ data: { image } }) => {
            const imagePreview = image.content.find(
              (img) => img.type === "square-large"
            );
            setDownloadedImage(imagePreview?.url || null);
            setIsImageDownloading(false);
          })
          .catch(() => toast.warning(t("app.image.edit.failed")));
      }
    },
    [imageId]
  );

  return { isImageDownloading, downloadedImage };
};

export { useGetImage };
